﻿/***************FILTERS DROPDOWNS START *********************/

let navFilterBtns = document.querySelectorAll(".nav-filter-item .nav-filter-item-dropdown");

if (navFilterBtns.length !== 0) {
    navFilterBtns.forEach(btn => btn.addEventListener('click', setActiveFilterBtn));
}

function setActiveFilterBtn(event) {
    navFilterBtns.forEach(btn => {
        if (btn !== event.target) {
            btn.classList.remove('active');
            btn.nextElementSibling.classList.remove('active')
        }
    });
    event.target.classList.toggle('active');
    event.target.nextElementSibling.classList.toggle('active');
}

let navFilter = document.querySelector('.nav-filter');

if (navFilter) {
    navFilter.addEventListener("click", (event) => {
        console.log(event.target.classList);

        let navFilterItemDropdown = document.querySelector("#nav-filter-sortBy .nav-filter-item-dropdown");
        let navFilterDropdownContent = document.querySelector("#nav-filter-sortBy .nav-filter-dropdown-content");
        let mobileNavFilterItemDropdown = document.querySelector("#mobile-nav-filter .nav-filter-item-dropdown");
        let mobileNavFilterDropdownContent = document.querySelector("#mobile-nav-filter .nav-filter-dropdown-content");

        if (!event.target.classList.contains("sortByFilter") && navFilterItemDropdown && navFilterDropdownContent) {
            navFilterItemDropdown.classList.remove("active");
            navFilterDropdownContent.classList.remove("active");
        }
        if (!event.target.classList.contains("navFilter") && mobileNavFilterItemDropdown && mobileNavFilterDropdownContent) {
            mobileNavFilterItemDropdown.classList.remove("active");
            mobileNavFilterDropdownContent.classList.remove("active");
        }
    });

    // -------- Hide filters dropdown when click on page ----------------

    let body = document.querySelector('body');
    body.addEventListener('click', hideFilterDropdowns);

    function hideFilterDropdowns(event) {
        if (!event.target.closest('.nav-filter-item')) {
            let dropDowns = document.querySelectorAll('.nav-filter-dropdown-content');
            if (dropDowns.length !== 0) {
                dropDowns.forEach(item => {
                    item.classList.remove('active');
                    item.previousElementSibling.classList.remove('active');
                });
            }
        }
    }
}

/***************FILTERS DROPDOWNS END *********************/